export enum AccessReason {
  New,
  Owner,
  GrantedAccess,
}
